import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="bg-white">
      <section className="bg-white">
        <div className="mx-3 md:mx-10 lg:mx-16 py-16 md:py-20">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-4xl md:text-5xl font-inter font-medium text-acBlack leading-[1.05]">
              Privacy Policy
            </h1>

            <div className="mt-6 rounded-2xl bg-gray-50 border border-gray-100 px-6 md:px-8 py-5">
              <div className="text-sm md:text-base text-acGray font-inter">
                <span className="font-semibold text-acBlack">Effective Date:</span> 24th May 2025
              </div>
            </div>

            <div className="mt-10 space-y-10">
              <div className="text-sm md:text-base text-gray-700 font-inter leading-relaxed">
                Validate Systems (“we”, “our”, “us”) operates the website valicourses.com (the “Website”). This Privacy
                Policy explains how we handle information when you visit or use our Website.
              </div>

              <div className="space-y-4">
                <h2 className="text-xl md:text-2xl font-inter font-semibold text-acBlack">1. About Valicourses</h2>
                <p className="text-sm md:text-base text-gray-700 font-inter leading-relaxed">
                  Valicourses is a curated course discovery platform operated by Validate Systems. We showcase and link to
                  business and technology courses that are hosted and sold on third-party platforms. We do not host
                  courses, process payments, or provide learning services directly.
                </p>
              </div>

              <div className="space-y-4">
                <h2 className="text-xl md:text-2xl font-inter font-semibold text-acBlack">2. Information We Collect</h2>

                <div className="space-y-3">
                  <h3 className="text-base md:text-lg font-inter font-semibold text-acBlack">a. Personal Information</h3>
                  <p className="text-sm md:text-base text-gray-700 font-inter leading-relaxed">
                    We do not collect personal identifiable information (PII) directly from visitors on this Website.
                  </p>

                  <ul className="mt-2 space-y-2 text-sm md:text-base text-gray-700 font-inter">
                    <li>We do not require user accounts</li>
                    <li>We do not collect names, email addresses, or payment details</li>
                    <li>We do not process transactions</li>
                  </ul>

                  <p className="text-sm md:text-base text-gray-700 font-inter leading-relaxed">
                    Any personal information you provide when purchasing a course is collected directly by the third-party
                    platform you choose to use.
                  </p>
                </div>

                <div className="space-y-3">
                  <h3 className="text-base md:text-lg font-inter font-semibold text-acBlack">
                    b. Automatically Collected Information
                  </h3>
                  <p className="text-sm md:text-base text-gray-700 font-inter leading-relaxed">
                    At this time, we do not use analytics tools, tracking pixels, or cookies to collect usage data from
                    visitors.
                  </p>
                </div>
              </div>

              <div className="space-y-4">
                <h2 className="text-xl md:text-2xl font-inter font-semibold text-acBlack">3. Third-Party Platforms</h2>
                <p className="text-sm md:text-base text-gray-700 font-inter leading-relaxed">
                  Valicourses contains links to third-party platforms where courses are hosted and sold, including but not
                  limited to:
                </p>

                <ul className="mt-2 space-y-2 text-sm md:text-base text-gray-700 font-inter">
                  <li>Selar</li>
                  <li>Lemon Squeezy</li>
                  <li>Gumroad</li>
                  <li>Udemy</li>
                </ul>

                <p className="text-sm md:text-base text-gray-700 font-inter leading-relaxed">
                  When you click a course link, you are redirected to an external website that operates under its own
                  privacy policy and terms. We are not responsible for the privacy practices, content, or security of
                  these third-party platforms.
                </p>

                <p className="text-sm md:text-base text-gray-700 font-inter leading-relaxed">
                  We encourage you to review their privacy policies before providing any personal information.
                </p>
              </div>

              <div className="space-y-4">
                <h2 className="text-xl md:text-2xl font-inter font-semibold text-acBlack">4. Payments and Course Access</h2>
                <p className="text-sm md:text-base text-gray-700 font-inter leading-relaxed">Valicourses does not:</p>

                <ul className="mt-2 space-y-2 text-sm md:text-base text-gray-700 font-inter">
                  <li>Process payments</li>
                  <li>Store payment information</li>
                  <li>Deliver course content</li>
                </ul>

                <p className="text-sm md:text-base text-gray-700 font-inter leading-relaxed">
                  All payments, access, and learning experiences are handled entirely by the respective third-party course
                  provider.
                </p>
              </div>

              <div className="space-y-4">
                <h2 className="text-xl md:text-2xl font-inter font-semibold text-acBlack">5. Cookies</h2>
                <p className="text-sm md:text-base text-gray-700 font-inter leading-relaxed">
                  Valicourses does not use cookies for tracking, advertising, or analytics purposes.
                </p>
                <p className="text-sm md:text-base text-gray-700 font-inter leading-relaxed">
                  Third-party platforms you are redirected to may use cookies according to their own policies.
                </p>
              </div>

              <div className="space-y-4">
                <h2 className="text-xl md:text-2xl font-inter font-semibold text-acBlack">6. Data Security</h2>
                <p className="text-sm md:text-base text-gray-700 font-inter leading-relaxed">
                  Since we do not collect or store personal data, we do not maintain databases of user information.
                  However, we take reasonable measures to ensure the Website itself is secure and accessible.
                </p>
              </div>

              <div className="space-y-4">
                <h2 className="text-xl md:text-2xl font-inter font-semibold text-acBlack">7. International Users</h2>
                <p className="text-sm md:text-base text-gray-700 font-inter leading-relaxed">
                  Valicourses operates from Nigeria but is accessible globally. By using the Website, you acknowledge that
                  any interaction with third-party platforms may involve the transfer of data across international
                  borders, subject to those platforms’ privacy policies.
                </p>
              </div>

              <div className="space-y-4">
                <h2 className="text-xl md:text-2xl font-inter font-semibold text-acBlack">8. Children’s Privacy</h2>
                <p className="text-sm md:text-base text-gray-700 font-inter leading-relaxed">
                  Valicourses is not intended for individuals under the age of 18. We do not knowingly collect
                  information from children.
                </p>
              </div>

              <div className="space-y-4">
                <h2 className="text-xl md:text-2xl font-inter font-semibold text-acBlack">9. Changes to This Privacy Policy</h2>
                <p className="text-sm md:text-base text-gray-700 font-inter leading-relaxed">
                  We may update this Privacy Policy from time to time to reflect changes to our Website or legal
                  requirements. Updates will be posted on this page with a revised effective date.
                </p>
              </div>

              <div className="space-y-4">
                <h2 className="text-xl md:text-2xl font-inter font-semibold text-acBlack">10. Contact Us</h2>
                <p className="text-sm md:text-base text-gray-700 font-inter leading-relaxed">
                  If you have questions or concerns about this Privacy Policy, you may contact us at:
                </p>

                <div className="rounded-2xl bg-white border border-gray-100 px-6 md:px-8 py-6">
                  <div className="text-sm md:text-base text-acBlack font-inter font-semibold">Validate Systems</div>
                  <div className="mt-2 text-sm md:text-base text-gray-700 font-inter leading-relaxed">
                    36, Ilupeju Street, Camp FUNAAB
                    <br />
                    Ogun State, Nigeria
                  </div>
                  <div className="mt-4 text-sm md:text-base text-gray-700 font-inter">
                    <span className="font-semibold text-acBlack">Email:</span> privacy@valicourses.com
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
